<script setup lang="ts">
  import {authStore} from "#imports";

  const route = useRoute()
  const {user} = authStore()

</script>

<template>
  <div class="left-nav">
    <ul class="list-unstyled">
      <li><nuxt-link v-if="user?.level === 'normal'" :class="{'selected-link': route.path === '/payments/online'}" to="/payments/online"><i
          class="fas fa-plus-circle"></i> <span class="priority-text">Onlayn qaydada 7/24</span>
      </nuxt-link></li>
      <li><nuxt-link :class="{'selected-link': route.path === '/payments'}" to="/payments"><i
          class="fas fa-plus-circle"></i> Qəbz ilə 11:00–00:00
      </nuxt-link></li>
    </ul>
  </div>
</template>

<style scoped>
.priority-text {
  position: relative;
  animation: pulse 1.5s infinite;
  font-weight: bold;
}

@keyframes pulse {
  0% {
    color: inherit;
    text-shadow: none;
  }
  50% {
    color: #ff6b00;
    text-shadow: 0 0 5px rgba(255, 107, 0, 0.5);
  }
  100% {
    color: inherit;
    text-shadow: none;
  }
}

/* Optional: add a small badge or indicator */
.priority-text::after {
  content: "★";
  position: relative;
  top: -8px;
  right: -3px;
  font-size: 0.7em;
  color: #ff6b00;
  animation: star-pulse 1.5s infinite alternate;
}

@keyframes star-pulse {
  0% {
    opacity: 0.5;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1.2);
  }
}
</style>